<div class="custom-tooltip-container display-flex" *ngIf="text || contentTemplate">
  <ng-template #simpleText>
    <div *ngIf="text" class="body-small">{{ text }}</div>
  </ng-template>
  <ng-container *ngTemplateOutlet="contentTemplate || simpleText"></ng-container>
</div>
